import routeName from '@/router/constant';
import { guideRoutes } from '@/utils/guideRoutes';
import aplCatlCode from '@/json/aplCatlCode';
import codeList from '@/json/codeList';

const aplCatl = aplCatlCode.CREDIT_CARD_AUTH;
const code = codeList.CREDIT_CARD_AUTH;

export const routesCreditCardAuth = [
    {
        path: 'credit-card-auth-term',
        name: routeName.CREDIT_CARD_AUTH_TERMS,
        component: () => import('@/views/aplCatlCreditCardAuth/authTerms/Index.vue'),
        meta: { auth: true, metaTitle: '續期信用卡授權約定條款', leaveAlert: true, code, pageTitle: '申請信用卡授權', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.CONFIRM_DATA, routeName.EDIT_TEL_MAIL, routeName.HOME];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
    {
        path: 'credit-card-auth-info',
        name: routeName.CREDIT_CARD_AUTH_CARD_INFO,
        component: () => import('@/views/aplCatlCreditCardAuth/creditCardInfo/Index.vue'),
        meta: { auth: true, metaTitle: '信用卡卡號效期輸入', leaveAlert: true, code, pageTitle: '申請信用卡授權', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.CONFIRM_DATA, routeName.CREDIT_CARD_AUTH_TERMS];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
    {
        path: 'credit-card-auth-policy',
        name: routeName.CREDIT_CARD_AUTH_POLICY,
        component: () => import('@/views/aplCatlCreditCardAuth/selectPolicy/Index.vue'),
        meta: { auth: true, metaTitle: '申請信用卡授權保單列表', leaveAlert: true, code, pageTitle: '申請信用卡授權', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.CONFIRM_DATA, routeName.CREDIT_CARD_AUTH_CARD_INFO];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
];
